import React from "react";

export default function NotLogin() {
  return <div>로그인이 안 되어 있네. 로그인 먼저 하세요</div>;
}
